import { selectBasketCheckout, selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import usePaymentProcessing from './hooks/usePaymentProcessing'
import { useState, useEffect, useRef } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getPaymentIcon } from './utils'
import Option from 'components/Option'
import Error from 'components/Error'
import BlikPopup from './BlikPopup'
import Summary from './Summary'
import { v7 } from 'uuid'
import './style.scss'

const Payment = ({ price, action, primaryTheme = true }) => {
  const { popup } = usePopupState()
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const checkout = useSelector(selectBasketCheckout)
  const [isLoading, setLoading] = useState(false)
  const [warning, setWarning] = useState('')
  const [selected, select] = useState({
    methodId: ''
  })

  const bottomRef = useRef(null)
  const thereArePaymentMethods = checkout?.payments && checkout.payments.length > 0

  const { replace } = useHistory()
  const { t } = useTranslation('payment')
  const { purchase, callback, generateBody } = usePaymentProcessing(
    selected,
    isLoading,
    setLoading
  )

  const validateForm = () => {
    if (selected.methodId) {
      if (warning) setWarning('')
      if (action) action()
      else purchase()
    } else {
      setWarning('Musisz wybrać metodę płatności!')
    }
  }

  useEffect(() => {
    if (isBasketEmpty) replace('/map')
    // We need this only on startup!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replace])

  useEffect(() => {
    if (selected.methodId) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [selected.methodId])


  return (
    <>
      {popup && <div>
        {popup.type === 'blik'
          ? (() => {
            let localPaymentId = ''
            return <BlikPopup
              callback={remotePaymentId => {
                callback(remotePaymentId
                  ? { ...popup.payment, localPaymentId, remotePaymentId }
                  : undefined)
              }}
              getBody={code => {
                localPaymentId = v7()
                return generateBody(localPaymentId, code)
              }}
            />
          })()
          : null}
      </div>}

      <div className={`payment --${primaryTheme ? 'primary' : 'secondary'}`}>
        <div className='title'>
          <div>{t('payment')}</div>
          <div>{t('chooseOneOfOptions')}</div>
        </div>

        <div className='payment__main center'>
          <div>
            <Summary price={price} />
            <p>{t('methodsAvailable')}</p>
            {warning && <p className='--warning'>{warning}</p>}

            <div
              className='payment__methods'
              style={isLoading ? { opacity: 0.5 } : undefined}>
              {thereArePaymentMethods
                ? checkout.payments.map((payment) => {
                  if (payment.key === 'applepay' && !window.ApplePaySession) return null
                  const { id, name, description, isBlocked } = payment
                  const isSelected = selected.methodId === id
                  const icon = getPaymentIcon(payment)

                  return <Option
                    key={id}
                    icon={icon}
                    title={name}
                    desc={description}
                    selected={isSelected}
                    action={() => {
                      if (isBlocked || isLoading) return
                      select({ methodId: id })
                    }} />
                })
                : <Error
                  staticPos
                  text={t('noPaymentMethods')}
                />}
            </div>

            <ArrowBtn
              enlarged
              text={t('payNow')}
              isLoading={isLoading}
              disabled={!thereArePaymentMethods}
              action={validateForm} />

            <BackBtn />
            <div ref={bottomRef} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Payment